import { use } from "react";
import {
  CalculatorContext,
  type CalculatorState,
} from "../context/CalculatorContext";

export function useCalculator<U>(selector: (state: CalculatorState) => U): U {
  const context = use(CalculatorContext);

  if (context === null) {
    throw new Error(
      "useCalculator must be used within a CalculatorContext.Provider",
    );
  }

  return context.useCalculator(selector);
}
